import { Cookies } from 'react-cookie'

import { getPageURL } from './page-url'

/**
 * Age Gating Lock
 * Lock the user for a given amount of time if they are underage
 */
export const lockAgeGate = (ageGateSettings, lockCookieName) => {
  const cookies = new Cookies()
  const currentDomain = `${getPageURL('domain')}`

  if (ageGateSettings && ageGateSettings.locking) {
    cookies.set(lockCookieName, true, {
      domain: `${currentDomain}`,
      path: '/',
      maxAge: 7200
    })
  }
}